var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoLightDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M18.6666 5.33331H5.33325C3.12392 5.33331 1.33325 7.12398 1.33325 9.33331V22.6666C1.33325 24.876 3.12392 26.6666 5.33325 26.6666H18.6666C20.8759 26.6666 22.6666 24.876 22.6666 22.6666V21.3333L25.3333 16L22.6666 10.6573V9.33331C22.6666 7.12398 20.8759 5.33331 18.6666 5.33331Z",
    fill: "black",
    fillOpacity: 0.95
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0004 29.3333C27.6591 29.3333 27.3177 29.2027 27.0577 28.9427L3.05775 4.94265C2.53641 4.42132 2.53641 3.57865 3.05775 3.05732C3.57908 2.53599 4.42175 2.53599 4.94308 3.05732L28.9431 27.0573C29.4644 27.5787 29.4644 28.4213 28.9431 28.9427C28.6831 29.2027 28.3417 29.3333 28.0004 29.3333Z",
    fill: "black",
    fillOpacity: 0.95
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 10.6573L27.5427 8.228C27.8441 8.07733 28.1747 8 28.5107 8C29.7041 8 30.6734 8.96267 30.6814 10.156L30.7641 21.8133C30.7734 23.0187 29.7987 24 28.5934 24H28.5121C28.1747 24 27.8427 23.9213 27.5414 23.7707L22.6667 21.3333V10.6573Z",
    fill: "black",
    fillOpacity: 0.95
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoLightDisabled);
export default __webpack_public_path__ + "static/media/video-light-disabled.2c71731cbc629bb44756d5e262fb3d97.svg";
export { ForwardRef as ReactComponent };